module.exports = __webpack_public_path__ + "img/es.51196993.png";